import { createElement } from 'react';
import { useUniqueId } from '../uniqueId.js';
import { string, shape, oneOfType, node, func, element, bool, oneOf } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import 'reakit/Portal';
import '../Portal/styled.js';
import '../Portal/index.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import { actionButtonsPropTypes } from '../Button/ActionButtons.js';
import '../Button/index.js';
import 'classnames';
import 'reakit/Heading';
import '../Heading/styled.js';
import '../Heading/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import 'reakit/Backdrop';
import '../Backdrop/styled.js';
import '../Backdrop/index.js';
import 'reakit/Overlay';
import '../Overlay/OverlayContainer.js';
import '../Overlay/styled.js';
import '../Overlay/OverlayHide.js';
import '../Overlay/OverlayShow.js';
import '../Overlay/OverlayToggle.js';
import '../chunk-7b491460.js';
import '../Overlay/index.js';
import '../chunk-5c9bbccf.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Dialog/styled.js';
import '../Dialog/DialogDialog.js';
import '../Dialog/DialogContent.js';
import '../Dialog/DialogHeader.js';
import '../Dialog/DialogFooter.js';
import '../Dialog/DialogTitle.js';
import '../Dialog/DialogClose.js';
import '../Dialog/DialogIcon.js';
import Dialog from '../Dialog/index.js';
import '../Modal/ModalContainer.js';
import '../Modal/styled.js';
import '../Modal/ModalHide.js';
import '../Modal/ModalShow.js';
import { a as modalPropTypes, b as modalDefaultProps, c as Modal } from '../chunk-b0f88be0.js';

var DialogModal = function DialogModal(_ref) {
  var _a11yDescriptionId = _ref.a11yDescriptionId,
      _a11yTitleId = _ref.a11yTitleId,
      actionButtonsProps = _ref.actionButtonsProps,
      children = _ref.children,
      footer = _ref.footer,
      hasScroll = _ref.hasScroll,
      hide = _ref.hide,
      kind = _ref.kind,
      showActionButtons = _ref.showActionButtons,
      showCloseButton = _ref.showCloseButton,
      title = _ref.title,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yDescriptionId", "a11yTitleId", "actionButtonsProps", "children", "footer", "hasScroll", "hide", "kind", "showActionButtons", "showCloseButton", "title", "type"]);

  var titleId = useUniqueId('DialogModal');
  var descriptionId = useUniqueId('DialogModal');
  var a11yDescriptionId = _a11yDescriptionId || descriptionId;
  var a11yTitleId = _a11yTitleId || titleId;
  return createElement(Modal, _extends({
    hide: hide,
    kind: kind
  }, props), function (_ref2) {
    var fallbackFocusRef = _ref2.fallbackFocusRef,
        initialFocusRef = _ref2.initialFocusRef;
    return createElement(Dialog, {
      a11yDescriptionId: a11yDescriptionId,
      a11yTitleId: a11yTitleId,
      actionButtonsProps: _objectSpread({
        cancelProps: _objectSpread({
          elementRef: initialFocusRef,
          use: Modal.Hide,
          // @ts-ignore
          hide: hide
        }, (actionButtonsProps || {}).cancelProps),
        palette: type
      }, actionButtonsProps),
      closeButtonProps: {
        elementRef: initialFocusRef
      },
      elementRef: fallbackFocusRef // @ts-ignore
      ,
      footer: typeof footer === 'function' ? footer({
        initialFocusRef: initialFocusRef
      }) : footer,
      hasScroll: hasScroll,
      onClickClose: hide,
      role: kind === 'alert' ? 'alertdialog' : 'dialog',
      showActionButtons: showActionButtons || kind === 'alert',
      showCloseButton: showCloseButton && kind !== 'alert',
      tabIndex: -1 // @ts-ignore
      ,
      title: title,
      type: type,
      width: "100%"
    }, typeof children === 'function' ? children({
      initialFocusRef: initialFocusRef
    }) : children);
  });
};
var dialogModalPropTypes = _objectSpread({}, modalPropTypes, {
  a11yDescriptionId: string,
  a11yTitleId: string,
  actionButtonsProps: shape(actionButtonsPropTypes),
  children: oneOfType([node, func]).isRequired,
  footer: oneOfType([func, string, element]),
  hasScroll: bool,
  kind: oneOf(['alert']),
  title: oneOfType([string, element]),
  type: string
});
DialogModal.propTypes = dialogModalPropTypes;
var dialogModalDefaultProps = _objectSpread({}, modalDefaultProps, {
  actionButtonsProps: {},
  a11yDescriptionId: undefined,
  a11yTitleId: undefined,
  footer: undefined,
  hasScroll: false,
  kind: undefined,
  title: undefined,
  type: undefined,
  hideOnEsc: true,
  hideOnClickOutside: true
});
DialogModal.defaultProps = dialogModalDefaultProps; // @ts-ignore

var C = DialogModal;

export default C;
export { C as DialogModal, dialogModalDefaultProps, dialogModalPropTypes };
